"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwToggleButton = _interopRequireDefault(require("../cwtogglebutton/CwToggleButton"));

var CwToggleButtonGroup = function CwToggleButtonGroup(props) {
  var createToggleButton = function createToggleButton(item) {
    if (!props.value || props.value.id === undefined) {
      return;
    }

    var value = item.id === props.value.id;

    var toggleButton = _react.default.createElement(_CwToggleButton.default, {
      cwId: "".concat(props.cwId, "_").concat(item.id),
      item: item,
      text: item.name,
      key: item.id,
      onClick: function onClick(item) {
        return props.onChange(item);
      },
      value: value,
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      tabIndex: props.tabIndex
    });

    return _react.default.createElement("td", {
      key: item.id
    }, toggleButton);
  };

  var getToggleButtons = function getToggleButtons() {
    if (!props.toggleButtons || !props.toggleButtons.length > 0) {
      return null;
    }

    var columns = props.columns ? props.columns : props.toggleButtons.length;
    var rows = [];
    var j = 0;
    var cells = [];

    for (var i = 0; i < props.toggleButtons.length; i++) {
      var item = props.toggleButtons[i];
      cells.push(createToggleButton(item));
      j++;

      if (j > columns - 1 || i === props.toggleButtons.length - 1) {
        j = 0;
        rows.push(_react.default.createElement("tr", {
          key: "item{".concat(i)
        }, cells));
        cells = [];
      }
    }

    return _react.default.createElement("table", null, _react.default.createElement("tbody", {
      style: {
        width: '100%'
      }
    }, rows));
  };

  return getToggleButtons();
};

CwToggleButtonGroup.propTypes = {
  /**
  * Connectwise element id to be used as unique identifier
  */
  cwId: _propTypes.default.string,

  /**
   * Array of toggle buttons for the group with {id, name} as its shape
   */
  toggleButtons: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]).isRequired,
    name: _propTypes.default.string.isRequired
  })).isRequired,

  /**
   * Id of toggle button that should be checked, if it does not match
   * an id of a toggle button on  the props.toggleButtons, none will
   * be checked
   */
  value: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
    name: _propTypes.default.string
  }),

  /**
   * Used to lay out the toggle buttons, it will display the toggle buttons
   * across this many columns
   */
  columns: _propTypes.default.number,

  /**
   * Callback function fired when a toggle button in this group is clicked
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function fired when a toggle button is focued
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function fired when a toggle button is blured
   */
  onBlur: _propTypes.default.func,

  /**
   * used to control tab order
   */
  tabIndex: _propTypes.default.number,

  /**
   * Unused, added to satisfy pod element check
   */
  invalid: _propTypes.default.bool
};
CwToggleButtonGroup.defaultProps = {
  tabIndex: 0
};
var _default = CwToggleButtonGroup;
exports.default = _default;